var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"inline-block rounded-full px-2 text-xs",class:_vm.config[_vm.color].class},_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.showValue ? _vm.value : ''))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }